import React, { useState, useEffect, useRef } from 'react';
// import './CommonLayout.css';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import Sidebar from './sidebar/Sidebar';
import { useOnboardingStatus } from '../hooks/hooks';
import logoSrc from '../assets/images/logo.png';
import { useTranslation } from 'react-i18next';

const CommonLayout = () => {
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const { isOnboardingCompleted, isLoading } = useOnboardingStatus();
	const [currentUser, setCurrentUser] = useState(null);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);
	const navigate = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		try {
			const user = JSON.parse(localStorage.getItem('CurrentUser') || 'null');
			setCurrentUser(user);
		} catch (e) {
			setCurrentUser(null);
		}
	}, []);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownOpen(false);
			}
		};
		if (dropdownOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [dropdownOpen]);

	const getDisplayName = () => {
		if (!currentUser) return 'User';
		if (currentUser.firstName || currentUser.lastName) {
			return `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim();
		}
		return currentUser.name || currentUser.email || 'User';
	};

	const getInitials = () => {
		const name = getDisplayName();
		const parts = name.split(' ').filter(Boolean);
		const initials = parts.slice(0, 2).map(p => p[0]?.toUpperCase() || '').join('');
		return initials || 'U';
	};

	const handleLogout = () => {
		localStorage.removeItem('CurrentUser');
		localStorage.removeItem('AccessToken');
		localStorage.removeItem('UserRole');
		navigate('/login');
	};

	// Show loading while checking onboarding status
	if (isLoading) {
		return (
			<div className="flex items-center justify-center min-h-screen">
				<div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
			</div>
		);
	}

	// Redirect to onboarding if not completed
	if (!isOnboardingCompleted) {
		return <Navigate to="/onboarding" replace />;
	}

	return (
		<div className="h-[100vh] !overflow-hidden bg-gray-50">
			<header className="bg-gradient-to-r from-slate-50 to-white border-b border-slate-200 w-full">
				<div className="px-4 py-2">
					<div className="flex justify-between items-center">
						<div className="flex items-center">
							{/* Mobile Menu Button */}
							<button
								type="button"
								className="md:hidden lg:hidden -m-2 p-2 text-gray-600 hover:text-gray-900 mr-4"
								onClick={() => setSidebarOpen(true)}
							>
								<span className="sr-only">Open sidebar</span>
								<svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
								</svg>
							</button>
							<img className="h-10 w-auto ml-11" src={logoSrc} alt="Logo" />
						</div>
						<div ref={dropdownRef} className="relative">
							<button
								onClick={() => setDropdownOpen(o => !o)}
								className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-100 transition-colors"
							>
								<div className="w-9 h-9 rounded-full bg-slate-100 text-slate-800 flex items-center justify-center font-semibold">
									{getInitials()}
								</div>
								<span className="hidden sm:block text-sm font-medium text-slate-900">{getDisplayName()}</span>
								<svg className={`w-4 h-4 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
								</svg>
							</button>
							{dropdownOpen && (
								<div className="absolute right-0 mt-2 w-56 bg-white/95 backdrop-blur-sm text-gray-700 rounded-xl shadow-2xl ring-1 ring-black/10 overflow-hidden z-50 border border-white/20 animate-in slide-in-from-top-2 duration-200">
									<div className="py-2">
										{/* <button
											onClick={() => { setDropdownOpen(false); navigate('/profile'); }}
											className="w-full text-left px-4 py-3 text-sm hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-200 flex items-center gap-3 group"
										>
											<div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center group-hover:from-blue-200 group-hover:to-blue-300 transition-all duration-200">
												<svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
												</svg>
											</div>
											<div className="flex-1">
												<div className="font-medium text-gray-900 group-hover:text-blue-700 transition-colors duration-200">Profile</div>
										
											</div>
											<svg className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
											</svg>
										</button> */}

										{/* <button
											onClick={() => { 
												setDropdownOpen(false); 
												navigate(`/caterer-profile`);
											}}
											className="w-full text-left px-4 py-3 text-sm hover:bg-gradient-to-r hover:from-green-50 hover:to-emerald-50 transition-all duration-200 flex items-center gap-3 group"
										>
											<div className="w-8 h-8 rounded-lg bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center group-hover:from-green-200 group-hover:to-green-300 transition-all duration-200">
												<svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
												</svg>
											</div>
											<div className="flex-1">
												<div className="font-medium text-gray-900 group-hover:text-green-700 transition-colors duration-200">Caterers Profile</div>
												
											</div>
											<svg className="w-4 h-4 text-gray-400 group-hover:text-green-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
											</svg>
										</button> */}

										<button
											onClick={() => { setDropdownOpen(false); navigate('/setting'); }}
											className="w-full text-left px-4 py-3 text-sm hover:bg-gradient-to-r hover:from-purple-50 hover:to-violet-50 transition-all duration-200 flex items-center gap-3 group"
										>
											<div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center group-hover:from-purple-200 group-hover:to-purple-300 transition-all duration-200">
												<svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
												</svg>
											</div>
											<div className="flex-1">
												<div className="font-medium text-gray-900 group-hover:text-purple-700 transition-colors duration-200">{t('setting')}</div>
												
											</div>
											<svg className="w-4 h-4 text-gray-400 group-hover:text-purple-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
											</svg>
										</button>

										<div className="border-t border-gray-100 my-1"></div>

										<button
											onClick={handleLogout}
											className="w-full text-left px-4 py-3 text-sm hover:bg-gradient-to-r hover:from-red-50 hover:to-rose-50 transition-all duration-200 flex items-center gap-3 group"
										>
											<div className="w-8 h-8 rounded-lg bg-gradient-to-br from-red-100 to-red-200 flex items-center justify-center group-hover:from-red-200 group-hover:to-red-300 transition-all duration-200">
												<svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
												</svg>
											</div>
											<div className="flex-1">
												<div className="font-medium text-red-600 group-hover:text-red-700 transition-colors duration-200">{t('logout')}</div>
												
											</div>
											<svg className="w-4 h-4 text-red-400 group-hover:text-red-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
											</svg>
										</button>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</header>

			{/* Mobile Sidebar Overlay */}
			{sidebarOpen && (
				<div className="fixed inset-0 z-50 md:hidden">
					<div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)}></div>
					<div className="fixed inset-y-0 left-0 flex w-64 flex-col bg-white">
						<div className="flex h-16 items-center justify-between px-6 border-b border-gray-200">
							<div className="flex items-center">
								<div className="w-8 h-8 bg-gradient-to-r from-primary to-secondary rounded-lg flex items-center justify-center">
									<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
									</svg>
								</div>
								<span className="ml-3 text-lg font-semibold text-gray-900">Menu</span>
							</div>
							<button onClick={() => setSidebarOpen(false)} className="text-gray-400 hover:text-gray-600">
								<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
								</svg>
							</button>
						</div>
						{/* Mobile sidebar content */}
						<div className="flex-1 overflow-y-auto">
							<Sidebar onItemClick={() => setSidebarOpen(false)} />
						</div>
					</div>
				</div>
			)}

			<div className="flex h-[calc(100vh-72px)] overflow-hidden">
				{/* Desktop Sidebar */}
				<div className="hidden md:block lg:block w-64 bg-white border-r border-gray-200 h-full overflow-hidden">
					<Sidebar onItemClick={() => setSidebarOpen(false)}  />
				</div>

				{/* Content */}
				<div className="flex-1 h-full overflow-y-auto">
					<main className="">
						<div className="">
							<Outlet />
						</div>
					</main>
				</div>
			</div>
		</div>
	);
};

export default CommonLayout;